import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import { PageHeader, Loading, EmptyState } from "@/components/common";
import { Card } from "@/components/ui/card";
import { GraduationCap, BadgeCheck } from "lucide-react";

export default function MyQualifications() {
  const { data, isLoading } = useQuery({ queryKey: ["myQual"], queryFn: async () => (await api.get("/my/qualifications")).data });
  if (isLoading) return <Loading />;
  return (
    <div>
      <PageHeader overline="Education" title="My Qualifications" icon={GraduationCap}
        subtitle="Your verified academic and professional qualifications on record." />
      {(data || []).length === 0 ? (
        <EmptyState icon={GraduationCap} title="No qualifications recorded" hint="HR will add your verified qualifications." />
      ) : (
        <div className="grid sm:grid-cols-2 gap-4" data-testid="my-qualifications">
          {data.map((q) => (
            <Card key={q.id} className="p-5 border-slate-200 shadow-none">
              <div className="flex items-start justify-between">
                <div>
                  <p className="font-semibold text-navy">{q.qualification}</p>
                  <p className="text-sm text-slate-500 mt-0.5">{q.institution || "—"}{q.year ? ` · ${q.year}` : ""}</p>
                </div>
                {q.verified && <span className="inline-flex items-center gap-1 text-xs text-emerald-700 bg-emerald-50 rounded-full px-2 py-0.5"><BadgeCheck className="h-3.5 w-3.5" /> Verified</span>}
              </div>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
